module.exports = __webpack_public_path__ + "img/icon_revenue.07512fe3.svg";